import { ReactNode } from 'react';
import { type LucideIcon } from 'lucide-react';
import { useBreadcrumbs } from '@/client/hooks/use-breadcrumbs';
import StatsGrid, { type Stat } from '@/client/components/common/StatsGrid';

interface MarketingPageShellProps {
  title: string;
  description: string;
  crumbs: { label: string; href?: string }[];
  icon: LucideIcon;
  actions?: ReactNode;
  children: ReactNode;
  stats?: Stat[];
}

/**
 * Shared chrome for Marketing admin pages (mock-backed).
 * Page title lives in the sticky SiteHeader via breadcrumbs — this shell only
 * carries description, actions, and optional stats.
 */
export function MarketingPageShell({
  title: _title,
  description,
  crumbs,
  icon: _Icon,
  actions,
  children,
  stats = [],
}: MarketingPageShellProps) {
  useBreadcrumbs([{ label: 'Admin', href: '/admin' }, ...crumbs]);

  return (
    <div className="px-4 pb-2 md:px-6">
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 flex-1 items-start gap-2">
          <p className="max-w-2xl text-sm text-gray-500">{description}</p>
        </div>
        {actions}
      </div>

      {stats.length > 0 && <StatsGrid stats={stats} />}

      {children}
    </div>
  );
}
